import React from 'react';
import { components } from 'react-select';

import { LawSingleValuePropTypes } from 'src/components/JobChecklistForm/propTypes';
import s from './JobChecklistForm.styles';

const LawSingleValueComponent = ({ data, ...rest }) => (
  <components.SingleValue {...rest}>
    <s.LawTitle>{data.label}</s.LawTitle>
    <s.LawSecNumber>{data.articleSecNo}</s.LawSecNumber>
  </components.SingleValue>
);

LawSingleValueComponent.propTypes = LawSingleValuePropTypes;

export const LawSingleValue = React.memo(LawSingleValueComponent);
